import { render, staticRenderFns } from "./ModalProductReject.vue?vue&type=template&id=ae4aa784&scoped=true"
import script from "./ModalProductReject.vue?vue&type=script&lang=js"
export * from "./ModalProductReject.vue?vue&type=script&lang=js"
import style0 from "./ModalProductReject.vue?vue&type=style&index=0&id=ae4aa784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4aa784",
  null
  
)

export default component.exports